import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, map, of } from 'rxjs';
import { TimeSpan } from 'src/app/shared/helpers/time-span';
import { IFlexTimeCorrection } from '../models/flex-time-correction';
import { FlexTimeCorrectionService } from '../services/flex-time-correction.service';

@Injectable({
  providedIn: 'root'
})
export class FlexTimeCorrectionsResolver  {
  constructor(
    private flextimecorrectionService: FlexTimeCorrectionService
  ) { }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IFlexTimeCorrection[]> {
    return this.flextimecorrectionService.searchflextimecorrections({ pageNumber: 0, pageSize: 999999 })
      .pipe(
        map(data => {
          const response = data;
          response.data.map(corrections => {
            corrections.hours = TimeSpan.parse(corrections.hours).toStringShort();
          })

          return response;
        }),
        map(response => response.data)
      )
  }
}
